import { useConfigStore } from '@/store/use-config-store';
import { CUSTOMIZATION_MAP, DEFAULT_CUSTOMIZATION } from './customization';

export function useCustom() {
  const config = useConfigStore();
  const { enabledAuthTypes, ...others } =
    CUSTOMIZATION_MAP.get(config.clientId || config.entityId || '') ?? DEFAULT_CUSTOMIZATION;

  return {
    enabledAuthTypes,
    ...others,
    isSingleAuthType: enabledAuthTypes.length < 2,
  };
}
